var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.332,
    height: 18.249,
    viewBox: "0 0 15.332 18.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_143",
    "data-name": "Rettangolo 143",
    width: 15.332,
    height: 18.249,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_651",
    "data-name": "Raggruppa 651",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_651-2",
    "data-name": "Raggruppa 651",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_206",
    "data-name": "Tracciato 206",
    d: "M22.868,5.8h5.5L22,0V4.928a.869.869,0,0,0,.868.87",
    transform: "translate(-15.636 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_207",
    "data-name": "Tracciato 207",
    d: "M7.632,13.65h2.674a.289.289,0,0,0,.289-.289V9.115a.289.289,0,0,1,.289-.289h1.844V6.667h-5.5A1.736,1.736,0,0,1,5.5,4.931V0h-2.6v.01H.868A.868.868,0,0,0,0,.877V15.92a.868.868,0,0,0,.868.868H9.744L7.414,14.13a.289.289,0,0,1,.218-.48",
    transform: "translate(0 0.001)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_208",
    "data-name": "Tracciato 208",
    d: "M35.886,37.847V33.518a.3.3,0,0,0-.3-.295H34.484a.3.3,0,0,0-.295.295v4.329a.3.3,0,0,1-.3.3H32.3a.3.3,0,0,0-.222.489l1.267,1.446,1.475,1.682a.3.3,0,0,0,.443,0l1.475-1.682L38,38.632a.3.3,0,0,0-.222-.489h-1.6a.3.3,0,0,1-.3-.3",
    transform: "translate(-22.743 -23.612)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/IconDocuments.bdf399973c1d64728a4e11c942555e2e.svg";
export { ForwardRef as ReactComponent };